import Vue from 'vue';
import SearchBox from './components/search-box.vue';

export default class Box {
    constructor() {
        return this.constructor.load();
    }

    static load() {
        return new Vue({
            el: '#searchBoxApp',
            components: { SearchBox },
            methods: {
                search(query) {
                    this.onSearched(query);
                },
                onSearched() {}
            }
        });
    }
}
